module.exports = __webpack_public_path__ + "img/ihumane-green-short.2288b171.svg";